// Highdelberg Header: Mobilmenue, Zuechter-Dropdown, Ein- und Ausblenden beim Scrollen.
// Ab 990px scrollt bei Horizon .page-wrapper statt des Fensters, darum beide Quellen beobachten.
class HdscHeader extends HTMLElement {
  disconnectedCallback() { this.abort?.abort() }

  connectedCallback() {
    this.abort = new AbortController()
    const signal = this.abort.signal
    const menuBtn = this.querySelector('[data-menu]')
    const nav = this.querySelector('#hh-nav')
    const dropBtn = this.querySelector('[data-mega]')
    const mega = this.querySelector('#hh-mega')

    const setMenu = (open) => {
      this.classList.toggle('is-open', open)
      menuBtn?.setAttribute('aria-expanded', open)
    }
    menuBtn?.addEventListener('click', () => setMenu(!this.classList.contains('is-open')))
    nav?.addEventListener('click', (e) => { if (e.target.closest('a')) setMenu(false) })
    // Esc schliesst das Mobilmenue und gibt den Fokus an den Knopf zurueck
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) { setMenu(false); menuBtn?.focus() }
    }, { signal })

    if (dropBtn && mega) {
      const setMega = (open) => {
        mega.hidden = !open
        dropBtn.setAttribute('aria-expanded', open)
      }
      const hoverable = matchMedia('(hover: hover) and (min-width: 861px)')
      let leaveTimer, hoverOpenedAt = 0
      // Wer mit der Maus hinfaehrt und dann klickt, will es offen haben: Klick kurz nach Hover-Oeffnen schliesst nicht.
      dropBtn.addEventListener('click', () => {
        if (!mega.hidden && performance.now() - hoverOpenedAt < 600) return
        setMega(mega.hidden)
      })
      for (const el of [dropBtn, mega]) {
        el.addEventListener('pointerenter', () => {
          if (!hoverable.matches) return
          clearTimeout(leaveTimer)
          if (mega.hidden) hoverOpenedAt = performance.now()
          setMega(true)
        })
        el.addEventListener('pointerleave', () => { if (hoverable.matches) leaveTimer = setTimeout(() => setMega(false), 220) })
      }
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !mega.hidden) { setMega(false); dropBtn.focus() }
      }, { signal })
      document.addEventListener('click', (e) => {
        if (!mega.hidden && !e.target.closest('#hh-mega, [data-mega]')) setMega(false)
      }, { signal })
      // Fokus verlaesst Button und Panel (Tab, Shift+Tab): Panel schliessen, auf jeder Breite
      for (const el of [dropBtn, mega]) {
        el.addEventListener('focusout', (e) => {
          if (e.relatedTarget && !mega.contains(e.relatedTarget) && e.relatedTarget !== dropBtn) setMega(false)
        })
      }
    }

    // Fokus im Header holt ihn zurueck ins Bild (WCAG 2.4.11)
    this.addEventListener('focusin', () => this.classList.remove('is-hidden'))

    const wrapper = document.querySelector('.page-wrapper')
    let lastY = 0
    const onScroll = (e) => {
      const y = e.currentTarget === window ? window.scrollY : wrapper.scrollTop
      const busy = this.classList.contains('is-open') || (mega && !mega.hidden)
      this.classList.toggle('is-scrolled', y > 8)
      this.classList.toggle('is-hidden', y > lastY && y > 300 && !busy)
      lastY = y
    }
    window.addEventListener('scroll', onScroll, { passive: true, signal })
    wrapper?.addEventListener('scroll', onScroll, { passive: true, signal })

    // Horizon-Regeln (z. B. klebende Produktbilder) brauchen die Headerhoehe
    const setHeight = () => document.body.style.setProperty('--header-height', `${this.offsetHeight}px`)
    new ResizeObserver(setHeight).observe(this)
  }
}
if (!customElements.get('hdsc-header')) customElements.define('hdsc-header', HdscHeader)
